export default __webpack_public_path__ + "static/Scroll-Image---Concrete-Patio-Removal-80d763062260fbdebe7078bd9c8b5c89.jpg";